<svelte:options runes={true} />

<script module lang="ts">
  import type { IslandProps } from "~/types/islands";
  import type { Autosuggest } from "~/lib/listings/create-autosuggest.svelte";

  export interface Props extends IslandProps {
    accountId?: string;
    domainKey?: string;
    authKey?: string;
    initialQuery?: string;
    /** Stories and tests only — see SearchAutosuggestInner. */
    autosuggest?: Autosuggest;
  }
</script>

<script lang="ts">
  import { QueryClientProvider } from "@tanstack/svelte-query";
  import Theme from "~/components/Theme.svelte";
  import SearchAutosuggestInner from "./SearchAutosuggestInner.svelte";

  let { queryClient, accountId, domainKey, authKey, initialQuery, autosuggest }: Props = $props();
</script>

<QueryClientProvider client={queryClient}>
  <Theme class="da-search-autosuggest-island__root">
    <SearchAutosuggestInner {accountId} {domainKey} {authKey} {initialQuery} {autosuggest} />
  </Theme>
</QueryClientProvider>

<style>
  /* theme.css's unconditional `container-type: inline-size` on .da-root is free for
     islands mounting into a block-level container of definite width. This one mounts
     shrink-to-fit inside .header__search-wrapper, where it sized the island
     independently of its contents: width:0, trigger overlapping the account icon.
     Nothing here uses a container query, so the containment was only cost.

     Two classes, to beat theme.css's `:where(.da-root)` (0,0,0) without depending on
     layer or source order. `isolation: isolate` is separate and stays. Dropping the
     containment does mean .da-root is no longer the containing block for fixed
     descendants here — see ADR 0004. */
  :global(.da-root.da-search-autosuggest-island__root) {
    container-type: normal;
  }
</style>
